import { AuthService } from '../../features/auth/auth.service'
import { Injectable } from '@angular/core'
import { CanActivate, Router } from '@angular/router'
import { Observable } from 'rxjs'

@Injectable()
export class AdminAuthorized implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authService.isAdmin()) {
      return true
    }
    this.router.navigate(['auth'])
    return false
  }


}
